import type { ffDefaults } from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

type Props = {
  children: React.JSX.Element;
  featureFlag: keyof typeof ffDefaults;
  matches?: boolean;
};

/**
 * Conditonal render block. Only renders children if the flag is enabled.
 */
export const FeatureFlagged = ({ children, featureFlag, matches }: Props) => {
  const { flags, loading } = useFeatureFlags();

  return !loading && flags[featureFlag] === (matches ?? true) ? children : null;
};
